import { useEffect, useRef } from 'react';

/* Matches the design canvas: reveal a little before the element is fully in
 * view, and force everything visible after 2.6s in case the observer never
 * fires (short pages, restored scroll position, no IntersectionObserver). */
const OBSERVER_OPTIONS = { rootMargin: '0px 0px -8% 0px', threshold: 0.08 };
const SAFETY_MS = 2600;

export function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const show = () => node.classList.add('is-revealed');

    if (!('IntersectionObserver' in window)) {
      show();
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          show();
          observer.disconnect();
        }
      }
    }, OBSERVER_OPTIONS);

    observer.observe(node);
    const safety = setTimeout(show, SAFETY_MS);

    return () => {
      observer.disconnect();
      clearTimeout(safety);
    };
  }, []);

  return ref;
}
